import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  Button,
  FormRow,
  FormDashboardTextarea,
  ImagePickerSidebar
} from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'
import { X } from 'react-feather'

const JourneyPopup = ({onClose}) => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  const handleClose = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    if(typeof onClose === 'function'){
      onClose(false)
    }
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center overflow-y-auto"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto my-10 lg:my-0" onClick={(e) => e.stopPropagation()}>
        <div className="w-full lg:w-8/12 mx-auto px-4 py-5 lg:px-8 lg:py-8 bg-white rounded overflow-y-auto" style={{maxHeight: '90vh'}}>
          <div className="lg:w-auto mx-auto">

            <div className="flex justify-between items-center mb-5">
              <h1 className="text-lg lg:text-3xl text-left font-bold font-primary">
                Add New / Edit Journey
              </h1>
              <X onClick={handleClose}/>
            </div>

            <hr className="mb-5 lg:mb-10"/>
            <div className="lg:w-3/4">
              <FormRow>
                <Label>Title (English)</Label>
                <Input className="w-full" defaultValue="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint."/>
              </FormRow>
              <FormRow>
                <Label>Title (Indonesia)</Label>
                <Input className="w-full" defaultValue="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint."/>
              </FormRow>
              <FormRow>
                <Label>Description (English)</Label>
                <FormDashboardTextarea className="w-full" rows={3} defaultValue="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit."/>
              </FormRow>
              <FormRow>
                <Label>Description (Indonesia)</Label>
                <FormDashboardTextarea className="w-full" rows={3} defaultValue="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit."/>
              </FormRow>
              <FormRow>
                <Label>Add Image</Label>
                <ImagePickerSidebar height="100px"/>
              </FormRow>
              <div className="flex flex-wrap items-center">
                <Button
                  style={{maxWidth: isMobile ? '100%' : '197px'}}
                  thin={isMobile ? true : false}
                  className="mb-5 lg:mb-0"
                  onClick={handleClose}
                >
                  Add
                </Button>
                <div
                  className="text-center lg:text-left w-full lg:w-auto text-xs lg:text-sm text-gray-444 underline lg:ml-8 cursor-pointer"
                  onClick={handleClose}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { JourneyPopup }
